export default {
	18_24: 'De 18 à 24 ans',
	25_30: 'De 25 à 30 ans',
	31_40: 'De 31 à 40 ans',
	41_50: 'De 41 à 50 ans',
	51_60: 'De 51 à 60 ans',
	'60_plus': 'De 60 ans et plus',
	you_dont_have_this_badge_yet: 'Vous n&#39;avez pas encore ce badge',
	you_got_this_badge_on: 'Vous avez ce badge sur',
	accept_terms_and_conditions: 'J’accepte les termes et les conditions.',
	accept_terms: 'Accepter les termes',
	access_the_website_from_the: 'Accédez à votre profil dans le',
	activity_feed: 'Flux d’activité',
	age: 'Âge',
	approved: 'Approuvé',
	are_you_a_painter: 'Êtes-vous un peintre?',
	avatar_photo_optional: 'Avatar/Photo (facultative)',
	awaiting_approval: 'En attente de validation',
	birthday: 'Anniversaire',
	birthday_date: 'date de naissance',
	birthday_date_hint:
	'Pour le modifier, vous devez éditer toutes les données (année/mois/jour).',
	born_in: 'Anniversaire en',
	branch: 'Magasin',
	brand: 'Marque',
	cellphone: 'Téléphone portable',
	change_avatar: 'Changement d’avatar',
	change_phone: 'Changer de téléphone',
	verification_code_sent: 'Code de vérification envoyé',
	error_sending_verification_code: 'Erreur lors de l’envoi du code de vérification',
	change_password: 'Modifié le mot de passe',
	children: 'Enfants',
	city: 'Ville',
	commercial_phone: 'Téléphone commercial',
	company_agency: 'Entreprise/Agence',
	complement: 'Complément',
	communication_phone: 'Téléphone de communication',
	confirm_password: 'Confirmez le mot de passe',
	contact_information: 'Informations de contact',
	country: 'Pays',
	current_password: 'Mot de passe actuel',
	delivered: 'Livré',
	document_not_unique: 'Document déjà utilisé',
	each_level_has_exclusive_benefits_check_out_the:
		'Tous les niveaux ont des avantages. Consultez les',
	email_confirm: 'Confirmer le courriel',
	email_dont_match: 'Les courriels ne correspondent pas',
	email_receipt_change_successfully_changed:
		'La modification du reçu de courriel a bien été modifiée',
	error_changing_password_check_your_current_password_or_try_again_later:
		'Erreur lors du changement de mot de passe. Vérifiez votre mot de passe actuel ou réessayez plus tard',
	event_checkin: "Participation à l'événement",
	event_qrcode_checkin: 'Événements',
	female: 'Féminin',
	file_upload_reproval: 'Importation de photo refusée',
	file_upload: 'Importation de photo',
	from: 'de',
	gender: 'Genre',
	general: 'Général',
	gmin_number: 'Numéro GMIN',
	go_to_reward_store: 'Rejoindre l’espace des récompenses',
	handicap_description: 'Description du besoin spécial',
	i_agree_to_receive_interesting_emails_and_recommendations:
		"J'accepte de recevoir des e-mails et des recommandations intéressants",
	i_wish_to_receive_emails_from_intel_rewards_you_program:
		'Je souhaite être informé(e) par courrier des communication du programme',
	inbox: 'Boîte de Réception',
	information: 'Information',
	intel_retail_edge_program: 'Intel Retail® Edge Program',
	invalid_phone: 'Numéro de téléphone invalide',
	is_handicapped: 'Avec des besoins spéciaux?',
	justification: 'Justification',
	kdv_code: 'Code CADV',
	last_name: 'Nom de famille',
	level_up: 'Upgrade',
	male: 'Masculin',
	marital_status: 'État Civil',
	message: 'Message',
	mobile_phone: 'Téléphone portable',
	more_than: 'Plus que',
	my_data: 'Mes données',
	my_points: 'Mes Points',
	name: 'Nom',
	neighborhood: 'Arrondissement',
	new_password: 'Nouveau mot de passe',
	nickname: 'Surnom',
	no_address_found: 'Adresse introuvable',
	no_certificates_available: 'Aucun certificat trouvé',
	no_events_in_your_activity_feed_come_back_later:
		"Aucun événement dans votre flux d'activités. Revenez plus tard.",
	number_of_children: "Nombre d'enfants",
	number: 'Numéro',
	open_points_history: 'Voir l’ensemble des points',
	open_points_statement: 'Déclaration de point ouvert',
	order_history: 'Historique des commandes',
	order: 'Commande',
	orders: 'Commandes',
	others: 'Autres',
	painter: 'Peintre',
	password_changed_successfully: 'Le mot de passe a été changé avec succès',
	past_months: 'Les derniers mois',
	personal_information: 'Informations personnelles',
	phone_number: 'Téléphone',
	phone: 'Téléphone',
	phone_verified: 'Téléphone vérifié',
	phone_not_verified: 'Téléphone non vérifié. Vérifiez le message de validation du numéro sur votre WhatsApp.',
	phone_social_information: 'Confirmation requise',
	phone_to_receive_notifications_promotions_and_account_settings: 'Numéro de téléphone pour recevoir des notifications, des invitations et la récupération de compte.',
	points_earned_during_the_campaign: 'Points gagnés durant la campagne',
	profession: 'Profession',
	professional_information: 'Information professionnelle',
	profile_edited_successfully: 'Profil modifié avec succès',
	profile_successfully_changed: 'Profil modifié avec succès',
	program_rule: 'Règlement du programme',
	redeem: 'Échanger',
	register: 'Register',
	reject_terms: 'Refuser les conditions',
	reproved: 'Réprouver',
	resend_verification: 'Renvoyer la vérification',
	residential_phone: 'Téléphone fixe',
	retailer: 'Détaillant',
	sale_reproval: 'Ventes refusées',
	sale: 'Vente',
	search_address: 'Rechercher une adresse',
	search_by_street_name_and_number: 'Rechercher par nom et numéro de rue',
	see_all_badges: 'Voir toutes les badges',
	see_all_certificates: 'Voir tous les certificats',
	see_the_full_ranking: 'Voir le classement complet',
	select_profile: 'Sélectionner un profil',
	shipped: 'Expédié',
	show_ranking: 'Voir le classement',
	state: 'Pays',
	statement: 'Déclaration',
	store_nickname: 'Nom commercial (optionnel)',
	there_are_no_messages_available_at_the_moment: 'Aucun message disponible pour l’instant',
	these_data_cannot_be_changed: 'Ces données ne peuvent pas être modifiées.',
	this_campaign: 'Cette campagne',
	to_change_the_information_bellow: 'pour mettre à jour vos informations personnelles.',
	to: 'jusqu’à',
	total_credits_available_to_spend: 'Ensemble des crédits disponibles à dépenser',
	training_special: 'Prime de formation obligatoire',
	type_photo_upload: 'saisissez le téléchargement de photos',
	undefined: 'Je préfère ne pas révéler',
	user_avatar_changed: 'Avatar de l’utilisateur modifié',
	user_level_up: "Niveau d'utilisateur supérieur",
	user_registered: 'Registre d’utilisateur',
	we_couldnt_find_any_messages_with_the_current_search:
		'Nous n’avons trouvé aucun message avec la recherche actuelle.',
	whats_your_profession: 'Quelle est ta profession?',
	wait: 'Attendez',
	whatsapp: 'Whatsapp',
	you_dont_have_any_points_yet: "Vous n'avez pas encore de points",
	you_dont_have_certificates_in_this_category:
		'Vous n’avez pas encore de certificats dans cette catégorie',
	you_have: 'tu as',
	your_account_has_been_created_and_is_awaiting_for_aproval_you_will_receive_an_email:
		'Votre compte a été créé et attend son approbation vous recevrez un courriel',
	your_account_has_been_created_verify_your_email_for_instructions:
		'Votre compte vient d’être créé, vérifiez vos courriels pour plus d’instructions. N’oubliez pas de vérifier votre corbeille et(SPAM).',
	your_password_must_contain_at_least_characters_uppercase_letters_lowercase_letters_numbers_and_symbols:
		'Votre mot de passe doit contenir au moins 6 caractères, lettres majuscules, lettres minuscules, chiffres et symboles {symbols}',
	your_password_must_contain_at_least_characters_uppercase_letters_lowercase_letters_numbers:
		'Votre mot de passe doit contenir au moins 6 caractères, lettres majuscules, lettres minuscules, chiffres',
	your_password_must_contain_at_least_characters:
		'Votre mot de passe doit contenir au moins 6 caractères',
	your_ranking_position_will_be_available_after_you_complete_at_least_one_course:
		'Votre position de classement sera disponible après avoir terminé au moins un cours.',
}
